import {KpiResponse} from '@hconnect/common/types'
import {UseQueryOptions} from '@tanstack/react-query'
import axios from 'axios'

import {useSettingsQuery} from '@settings/modules/common/providers'
import {useUrlParam} from '@settings/modules/routing'

const kpiRetry = (failureCount: number, error: Error) => {
  const status = axios.isAxiosError(error) ? error.response?.status : undefined
  if (status === 404) return false
  return failureCount < 2
}

export const useKpis = (
  search?: string,
  options?: Omit<UseQueryOptions<KpiResponse, Error>, 'queryKey' | 'queryFn'>
) => {
  const plantCode = useUrlParam('plantCode')
  return useSettingsQuery('kpis', [{plantCode, search: search?.trim() ?? ''}], {
    retry: kpiRetry,
    ...options
  })
}

export const useKpiData = (isUpmNode: boolean, search?: string, includeChildren = false) => {
  const plantCode = useUrlParam('plantCode')
  const upmId = useUrlParam('nodeId')
  const trimmedSearch = search?.trim() ?? ''

  const plantKpis = useSettingsQuery('kpis', [{plantCode, search: trimmedSearch}], {
    retry: kpiRetry,
    enabled: !isUpmNode
  })
  const upmKpis = useSettingsQuery(
    'upmKpis',
    [{plantCode, upmId, includeChildren, search: trimmedSearch}],
    {
      retry: kpiRetry,
      enabled: isUpmNode
    }
  )

  return isUpmNode ? upmKpis : plantKpis
}
